export default __webpack_public_path__ + "static/media/Hana_Logo_White.19b12029.svg";